import ContactComponent from "@/components/Contact/ContactComponent";

const Contact = () => {
  return <ContactComponent />;
};

export default Contact;
